module.exports = __webpack_public_path__ + "img/gs.3df4d05a.svg";